package com.solevo.dist.network.firebase.api.invoice

import com.solevo.dist.application.models.Invoice
import com.solevo.dist.application.models.User.Companion.currentCustomerId
import com.solevo.dist.application.models.User.Companion.legalId
import com.solevo.dist.network.api.invoice.InvoiceRemoteSource
import com.solevo.dist.network.firebase.api.invoice.models.FirebaseInvoice
import com.solevo.dist.network.firebase.api.invoice.models.toInvoice
import com.solevo.dist.network.implementation.firebase.FirebaseFields
import com.solevo.dist.network.implementation.firebase.FirestoreCollections
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull

class InvoiceFirestoreRemoteSource : InvoiceRemoteSource {

    private val firestore = Firebase.firestore

    override fun getInvoicesForOrderLive(orderId: String): Flow<List<Invoice>> {
        return firestore.collection(FirestoreCollections.INVOICES_COLLECTION)
            .where { FirebaseFields.CUSTOMER_ID equalTo currentCustomerId.value }
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .where { FirebaseFields.ORDER_ID equalTo orderId }
            .snapshots
            .map { querySnapshot ->
                querySnapshot.documents.mapNotNull { it.data<FirebaseInvoice?>()?.toInvoice() }
            }
    }

    override fun getInvoice(id: String): Flow<Invoice?> {
        return firestore.collection(FirestoreCollections.INVOICES_COLLECTION)
            .where { FirebaseFields.INVOICE_ID equalTo id }
            .where { FirebaseFields.LEGAL_ENTITY_ID equalTo legalId }
            .where { FirebaseFields.CUSTOMER_ID equalTo currentCustomerId.value }
            .snapshots
            .map { querySnapshot ->
                querySnapshot.documents.map { it.data<FirebaseInvoice?>() }.firstOrNull()?.toInvoice()
            }
    }
}


